module.exports = __webpack_public_path__ + "img/PCS-logo.c566b11c.png";